import { Box, Button, Grid2 } from "@mui/material";
import { Link } from "react-router-dom";

export const MainTitle = (props) => {
  return (
    <Grid2 container spacing={2} justifyContent="center">
      <Grid2 size={{ xs: 12 }}>
        <Box className={`${props.className ? props.className : ""} mainTitle`}>
          <h2 dangerouslySetInnerHTML={{ __html: props.title }} />
          <p dangerouslySetInnerHTML={{ __html: props.paragraph }} />
        </Box>
      </Grid2>
    </Grid2>
  );
};

export const TitleButton = (props) => {
  return (
    <Grid2 container spacing={2} justifyContent="center">
      <Grid2 size={{ xs: 12 }}>
        <Box
          className={`${props.className ? props.className : ""} titleButton`}
        >
          <h2 dangerouslySetInnerHTML={{ __html: props.title }} />
          {props.buttonText && (
            <Link to={"/download-minecraft"}>
              <Button variant="contained" primary>
                {props.buttonText}
              </Button>
            </Link>
          )}
          <p dangerouslySetInnerHTML={{ __html: props.paragraph }} />
        </Box>
      </Grid2>
    </Grid2>
  );
};
